import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=35c1fdad&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1fdad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c1fdad')) {
      api.createRecord('35c1fdad', component.options)
    } else {
      api.reload('35c1fdad', component.options)
    }
    module.hot.accept("./ImageView.vue?vue&type=template&id=35c1fdad&scoped=true&", function () {
      api.rerender('35c1fdad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/BaseData/Venue/modules/ImageView.vue"
export default component.exports